module.exports = __webpack_public_path__ + "img/wallet.f90e06f0.svg";